import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    confirmed: {
      color: theme.palette.success.main,
      fontSize: theme.typography.pxToRem(11),
    },

    unconfirmed: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(11),
    },

    updateButton: {
      textTransform: 'inherit',
      textAlign: 'right',
      padding: 0,
    },

    capitalize: {
      textTransform: 'capitalize',
    },

    textRight: {
      textAlign: 'right',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    list: {
      maxHeight: 400,
      overflowY: 'auto',
    },

    cardContentPadding: {
      // padding: '24px 24px;'
    },

    userList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    userListItem: {
      width: '40%',
      padding: '0 4px 8px 0',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    primary: {
      fontSize: '13px',
      fontWeight: '600',
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };
});

const listItemsStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: '50px',
      wordBreak: 'break-all',
      textAlign: 'end',
    },
  };
});

export { useStyles, listTextStyles, listItemsStyles };
